import React from 'react';
import './viewer.css';

const PDFViewer = ({ file }: { file: string }) => {
  return <embed src={file} className="previewImage" />;
};

export default PDFViewer;
